<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.plus-circle-solid"></svg-vue>
          <h1 class="content-title">
            {{ $t('Create custom repair invoice') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-app" to="/workshop">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="content-card-body">
        <div class="p-5">
          <div class="px-4 py-8">
            <div class="flex items-center">
              <!-- step 1 -->
              <div :class="stepStage > 0 ? 'text-white' : 'text-gray-300'" class="flex items-center relative">
                <div
                  :class="stepStage > 0 ? 'bg-green-600 border-green-600' : 'text-gray-300 border-gray-300'"
                  class="rounded-full transition duration-500 ease-in-out h-12 w-12 py-3 border-2 text-center"
                >
                  1
                </div>
                <div :class="stepStage > 0 ? 'text-green-600' : 'text-gray-300'" class="absolute top-0 -ml-10 text-center mt-16 w-32 text-xs font-medium uppercase">
                  {{ $t('Repair Device') }}
                </div>
              </div>
              <!-- step 2 -->
              <div :class="stepStage > 1 ? 'border-green-600' : 'border-gray-300'" class="flex-auto border-t-2 transition duration-500 ease-in-out"></div>
              <div :class="stepStage > 1 ? 'text-white' : 'text-gray-300'" class="flex items-center relative">
                <div
                  :class="stepStage > 1 ? 'bg-green-600 border-green-600' : 'text-gray-300 border-gray-300'"
                  class="rounded-full transition duration-500 ease-in-out h-12 w-12 py-3 border-2 text-center"
                >
                  2
                </div>
                <div :class="stepStage > 1 ? 'text-green-600' : 'text-gray-300'" class="absolute top-0 -ml-10 text-center mt-16 w-32 text-xs font-medium uppercase">
                  {{ $t('Priority level') }}
                </div>
              </div>
              <!-- step 3 -->
              <div :class="stepStage > 2 ? 'border-green-600' : 'border-gray-300'" class="flex-auto border-t-2 transition duration-500 ease-in-out"></div>
              <div :class="stepStage > 2 ? 'text-white' : 'text-gray-300'" class="flex items-center relative">
                <div
                  :class="stepStage > 2 ? 'bg-green-600 border-green-600' : 'text-gray-300 border-gray-300'"
                  class="rounded-full transition duration-500 ease-in-out h-12 w-12 py-3 border-2 text-center"
                >
                  3
                </div>
                <div :class="stepStage > 2 ? 'text-green-600' : 'text-gray-300'" class="absolute top-0 -ml-10 text-center mt-16 w-32 text-xs font-medium uppercase">
                  {{ $t('Information & payment') }}
                </div>
              </div>
            </div>
          </div>
          <div class="mt-8 p-2">
            <loading :status="loading"></loading>
            <form @submit.prevent="submitRepair">
              <!-- content for step one -->
              <div :class="stepStage == 1 ? '' : 'hidden'" class="grid grid-cols-3">
                <!-- brand list start -->
                <div class="md:col-span-3">
                  <div class="py-3">
                    <div class="border-gray-200"></div>
                  </div>
                </div>
                <div class="md:col-span-1">
                  <h3 class="form-description-head">{{ $t('Enter device brand') }}</h3>
                  <p class="form-description-text">{{ $t('Brands we repair') }}.</p>
                </div>
                <div class="mt-5 md:mt-0 md:col-span-2">
                  <div class="grid grid-cols-3 gap-6">
                    <div class="col-span-3">
                      <label class="form-label" for="brand_info">{{ $t('Brand name') }}</label>
                      <div class="pt-1">
                        <input
                          :placeholder="$t('Brand name')"
                          class="form-input rounded-0
                        "
                          id="brand_info"
                          v-model="repair.brand_info.name"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- brand list end -->
                <!-- device list end -->
                <template v-if="repair.brand_info.name">
                  <div class="md:col-span-3">
                    <div class="py-3">
                      <div class="border-gray-200"></div>
                    </div>
                  </div>
                  <div class="md:col-span-1">
                    <h3 class="form-description-head">{{ $t('Enter device name') }}</h3>
                    <p class="form-description-text">{{ $t('Fill up device name and model') }}.</p>
                  </div>
                  <div class="mt-5 md:mt-0 md:col-span-2">
                    <div class="grid grid-cols-3 gap-6">
                      <div class="col-span-3">
                        <label class="form-label" for="device_info_name">{{ $t('Device name') }}</label>
                        <div class="pt-1">
                          <input
                            :placeholder="$t('Device name')"
                            class="form-input rounded-0
                        "
                            id="device_info_name"
                            v-model="repair.device_info.name"
                          />
                        </div>
                      </div>
                      <div class="col-span-3">
                        <label class="form-label" for="device_info_model">{{ $t('Device model') }}</label>
                        <div class="pt-1">
                          <input
                            :placeholder="$t('Device model')"
                            class="form-input rounded-0
                        "
                            id="device_info_model"
                            v-model="repair.device_info.model"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- device list end -->
                <!-- defects list start -->
                <template v-if="repair.device_info.name && repair.device_info.model">
                  <div class="md:col-span-3">
                    <div class="py-3">
                      <div class="border-gray-200"></div>
                    </div>
                  </div>
                  <div class="md:col-span-1">
                    <h3 class="form-description-head">{{ $t('Enter defect information') }}</h3>
                    <p class="form-description-text">{{ $t('Write the issues detail that need to be fixed, total price and total cost') }}.</p>
                  </div>
                  <div class="mt-5 md:mt-0 md:col-span-2">
                    <div class="grid grid-cols-3 gap-6">
                      <div class="col-span-3">
                        <label class="form-label" for="defects_info_title">{{ $t('Issues') }}</label>
                        <div class="pt-1">
                          <input :placeholder="$t('Issues or problems')" class="form-input rounded-0" id="defects_info_title" v-model="repair.defects_info.title" />
                        </div>
                      </div>
                      <div class="col-span-3">
                        <label class="form-label" for="defects_info_price">{{ $t('Price or charges') }}</label>
                        <div class="pt-1">
                          <input
                            :placeholder="$t('Price or charges')"
                            class="form-input rounded-0"
                            id="defects_info_price"
                            type="number"
                            min="0"
                            required
                            v-model="repair.defects_info.price"
                          />
                        </div>
                      </div>
                      <div class="col-span-3">
                        <label class="form-label" for="defects_info_cost">{{ $t('Cost') }}</label>
                        <div class="pt-1">
                          <input
                            min="0"
                            :placeholder="$t('Cost')"
                            class="form-input rounded-0"
                            type="number"
                            required
                            id="defects_info_cost"
                            v-model="repair.defects_info.cost"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- defects list end -->
              </div>
              <!-- end -->
              <!-- content for step two -->
              <div :class="stepStage == 2 ? '' : 'hidden'">
                <!-- priority list start -->
                <template v-if="priorityList.length">
                  <div class="md:col-span-3">
                    <div class="py-3">
                      <div class="border-t border-gray-200"></div>
                    </div>
                  </div>
                  <div class="md:col-span-1">
                    <h3 class="form-description-head">
                      {{ $t('Select priority') }}
                    </h3>
                    <p class="py-2 text-sm leading-5">{{ $t('Repair processing priority') }}.</p>
                  </div>
                  <div class="mt-5 md:mt-0 md:col-span-2">
                    <div class="grid grid-cols-3 gap-6">
                      <div class="col-span-3">
                        <div :style="{ maxHeight: '200px' }" class="flex flex-col overflow-y-auto">
                          <template v-for="(priority, index) in priorityList">
                            <div :key="index" @click="selectPriority(priority)" class="flex items-center px-6 py-3 hover:bg-gray-100 cursor-pointer rounded">
                              <div>
                                <div class="flex items-center justify-center">
                                  <svg-vue
                                    class="w-5 h-5 text-green-400"
                                    icon="font-awesome.check-circle-solid"
                                    v-if="repair.repair_priority_id === priority.id"
                                  ></svg-vue>
                                  <div class="w-5 h-5 p-1 overflow-hidden rounded-full border" v-else></div>
                                </div>
                              </div>
                              <div class="flex flex-col ml-6">
                                <p class="text-sm leading-5">
                                  {{ priority.name }}
                                </p>
                              </div>
                              <div class="ml-auto">
                                <small>{{ priority.extra_charge | currency }}</small>
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- priority list end -->
              </div>
              <!-- end -->
              <!-- content for step three -->
              <div :class="stepStage == 3 ? '' : 'hidden'">
                <div class="flex flex-col md:flex-row">
                  <div class="w-full mx-2 pb-3 flex-1 svelte-1l8159u">
                    <label class="form-label" for="name">
                      {{ $t('Name') }}
                    </label>
                    <div class="pt-1">
                      <input id="name" :placeholder="$t('Name')" class="form-input" required type="text" v-model="repair.name" />
                    </div>
                  </div>
                  <div class="w-full mx-2 pb-3 flex-1 svelte-1l8159u">
                    <label class="form-label" for="email">
                      {{ $t('Email address') }}
                    </label>
                    <div class="pt-1">
                      <input id="email" :placeholder="$t('Email address')" class="form-input" required type="email" v-model="repair.email" />
                    </div>
                  </div>
                </div>
                <div class="flex flex-col md:flex-row">
                  <div class="w-full mx-2 pb-3 flex-1 svelte-1l8159u">
                    <label class="form-label" for="phone">
                      {{ $t('Phone') }}
                    </label>
                    <div class="pt-1">
                      <input :placeholder="$t('Phone')" class="form-input" type="tel" id="phone" v-model="repair.phone" />
                    </div>
                  </div>
                  <div class="w-full mx-2 pb-3 flex-1 svelte-1l8159u">
                    <label class="form-label" for="serial_number">
                      {{ $t('Serial number') }}
                    </label>
                    <div class="pt-1">
                      <input id="serial_number" :placeholder="$t('Serial number')" class="form-input" v-model="repair.serial_number" />
                    </div>
                  </div>
                </div>

                <div class="flex flex-col md:flex-row">
                  <div class="w-full mx-2 pb-3 flex-1 svelte-1l8159u">
                    <label class="form-label" for="address">
                      {{ $t('Home address') }}
                    </label>
                    <div class="pt-1">
                      <input id="address" :placeholder="$t('Home address')" class="form-input" v-model="repair.address" />
                    </div>
                  </div>
                </div>
                <div class="flex flex-col md:flex-row">
                  <div class="w-full mx-2 pb-3 flex-1 svelte-1l8159u">
                    <label class="form-label" for="diagnostics">
                      {{ $t('Diagnostics') }}
                    </label>
                    <div class="pt-1">
                      <input-wysiwyg id="diagnostics" v-model="repair.diagnostics"></input-wysiwyg>
                    </div>
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="is_device_collected">{{ $t('Device collected status') }}</label>
                  <input-switch
                    :disabled-label="$t('The customer will be notified to dispatch device')"
                    :enabled-label="$t('The device has been just collected from customer')"
                    id="is_device_collected"
                    v-model="repair.is_device_collected"
                  ></input-switch>
                  <div class="form-description-text">{{ $t('This option will control to notify customer to dispatch his device via email') }}.</div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="has_warranty">{{ $t('Device warranty status') }}</label>
                  <input-switch :disabled-label="$t('No')" :enabled-label="$t('Yes')" id="has_warranty" v-model="repair.has_warranty"></input-switch>
                  <div class="form-description-text">{{ $t('This option will set device has warranty or not') }}.</div>
                </div>
                <div class="text-right px-4 py-3 sm:px-6">
                  <strong>{{ $t('Subtotal') }}</strong>
                  : {{ subTotalAmount | currency }}
                  <br />
                  <strong>{{ $t('Priority Process Charges') }}</strong>
                  : {{ currentPriority.extra_charge | currency }}
                  <br />
                  <strong>{{ $t('Tax') }}</strong>
                  : {{ taxAmount | currency }}
                  <br />
                  <strong>{{ $t('Total Amount') }}</strong>
                  : {{ totalAmountWithTax | currency }}
                </div>
                <div class="text-right px-4 py-3 sm:px-6">
                  <span class="inline-flex">
                    <router-link class="btn btn-secondary mr-4" to="/workshop/welcome">{{ $t('Close') }}</router-link>
                    <button class="btn btn-green" type="submit">
                      {{ $t('Save') }}
                    </button>
                  </span>
                </div>
              </div>
              <!-- end -->
            </form>
            <div class="mt-8 bg-gray-200 rounded-md text-right px-4 py-3 sm:px-6">
              <div class="flex justify-between">
                <button :disabled="stepStage < 2" @click="stepStage--" class="btn btn-app" type="reset">
                  {{ $t('Previous') }}
                </button>
                <button @click="stepStage++" class="btn btn-app" type="reset" v-if="!checkBeforeNext && stepStage < 3">
                  {{ $t('Next') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'new',
  metaInfo() {
    return {
      title: this.$i18n.t('Create manually repair order'),
      titleTemplate: `%s - ${this.$store.state.settings.name}`,
    };
  },
  data() {
    return {
      stepStage: 1,
      loading: false,
      priorityList: [],
      currentPriority: {
        extra_charge: 0,
      },
      repair: {
        is_manual: true,
        is_device_collected: false,
        name: null,
        email: null,
        phone: null,
        has_warranty: false,
        address: null,
        serial_number: null,
        diagnostics: null,
        brand_info: {
          name: null,
        },
        device_info: {
          avatar: '/images/default/icon.png',
          name: null,
          model: null,
          required_time: null,
        },
        defects_info: {
          title: null,
          price: 0,
          cost: 0,
        },
        repair_priority_id: 1,
        sub_total: 0,
        total_cost: 0,
        profit: 0,
        tax: 0,
        total_charges: 0,
        user_id: null,
        pre_paid: 0,
      },
      tax: {
        tax_rate: 0,
        is_tax_fix: false,
        is_tax_included: false,
      },
    };
  },
  mounted() {
    this.repair.user_id = this.$store.state.user.id;
    this.getBrandAndPriorityList();
  },
  computed: {
    checkBeforeNext() {
      const form = this.repair;
      if (this.stepStage === 1) {
        return !form.defects_info.title || !form.defects_info.price;
      }
      return false;
    },
    repairCostAmount() {
      return this.repair.defects_info.cost;
    },
    subTotalAmount() {
      return this.repair.defects_info.price;
    },

    profit() {
      return Number(this.subTotalAmount - this.repairCostAmount);
    },
    subTotalWithPriority() {
      const amount = Number(this.subTotalAmount) + Number(this.currentPriority.extra_charge);
      return amount;
    },
    taxAmount() {
      if (this.tax.is_vat) {
        let rating = '1.' + this.tax.tax_rate;
        if (this.tax.is_tax_included) {
          return Number(this.subTotalWithPriority - Number(this.subTotalWithPriority / rating));
        } else {
          return Number(Number(this.subTotalWithPriority * rating) - this.subTotalWithPriority);
        }
      } else {
        const rate = Number(this.tax.tax_rate);
        if (this.tax.is_tax_fix) {
          return rate;
        }
        return this.subTotalWithPriority * (rate / 100);
      }
    },
    totalAmountWithTax() {
      if (this.tax.is_tax_included) {
        return this.subTotalWithPriority;
      }
      return Number(this.subTotalWithPriority + this.taxAmount);
    },
  },
  methods: {
    selectPriority(priority) {
      this.currentPriority = priority;
      this.repair.repair_priority_id = priority.id;
    },
    submitRepair() {
      this.loading = true;
      this.repair.sub_total = this.subTotalAmount;
      this.repair.tax = this.taxAmount;
      this.repair.total_charges = this.totalAmountWithTax;
      this.repair.profit = this.profit;
      this.repair.total_cost = this.repairCostAmount;
      this.repair.payment_gateway_key = 'biller';
      this.repair.payment_gateway_value = this.$store.state.user.name;
      this.repair.user_id = this.$store.state.user.id;
      axios
        .post(route('repair-orders.store'), this.repair)
        .then((response) => {
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.loading = false;
          this.$router.push(`/print/repair-order/${response.data.order.uuid}`);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getBrandAndPriorityList() {
      this.loading = true;
      axios
        .get(route('repair.brand.list'))
        .then((response) => {
          this.priorityList = response.data.priorities;
          this.getTax();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getTax() {
      axios
        .get(route('settings.get.tax'))
        .then((response) => {
          this.tax = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
